import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { distinctUntilChanged, mergeMap, filter } from 'rxjs/operators';
import { Inject } from '@angular/core';
import { PollDataService, TrackingService } from '@services/index';

import { AuthService } from '@examsoft/es-login';
import { EulaService } from '@shared/services/eula.service';
import { environment } from '@environments/environment'

@Component({
  selector: 'eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss']
})
export class EulaComponent implements OnInit {
  esId: string;
  userAccepted: boolean;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private authService: AuthService,
    private trackingService: TrackingService,
    public router: Router,
    private eulaService: EulaService,
  ) {
  }

  agreementUrl = `${environment.urls.pltUrl}/agreements/examnow/examnow_terms_and_conditions.html`

  ngOnInit() {
    this.authService.loggedIn.pipe( distinctUntilChanged() )
    .subscribe( (data) => {
      this.esId = this.authService.user['custom:es-id'];
      if(data && this.storage.get('EULA')){
        this.router.navigateByUrl('/');
      }
    });
  }

  onSubmit(){
    this.userAccepted = true;
    console.log('submit clicked')
    this.trackingService.addPageAction('eula-checkbox', {
      'accepted': true
    });
    this.esId = this.authService.user['custom:es-id'];
    this.eulaService.acceptLatestAgreement(this.esId)
      .pipe(
        mergeMap(() => this.eulaService.hasAcceptedLatest(this.esId)),
        filter((data:any) => data.hasUserAcceptedLatest )
      ).subscribe( () => {
        window.location.href = '/';
      })
  }
}
